export default __webpack_public_path__ + "static/media/icon_WhiteMetal.cf040ada.png";